import base from './base2.repository';
export default {
    ...base,
    async getPersonEntriesByClient(clientId){
        const {data} = await this.get(`reporting/person-entries`, { client: clientId });
        return data;
    },
    async getClientDashboard(filters){
        return this.get(`reporting/client/dashboard`, filters);
    },
    getManagementReportData(filters){
        return this.get(`reporting/company/management-report-data`, filters);
    },
    async loadAdoptionData(clientId){
        const {data} = await this.get(`reporting/adoption/${clientId}/person-entries`);
        return data;
    },
    getPqrIndicators() {
        return this.get('reporting/pqr-indicators');
    },
    getPqrClientIndicators(clientId, year = '', month = '') {
        return this.get(`reporting/client/${clientId}/pqr-indicators`, {year, month});
    },
    getPqrClientFigures(clientId, year = '', month = '') {
        return this.get(`reporting/client/${clientId}/pqr-figures`, {year, month});
    },
    getOperationalIndicatorsByClient(clientId) {
        return this.get(`reporting/client/${clientId}/operational-indicators`);
    },
    getOperationalIndicatorsByCity(cityId) {
        return this.get(`reporting/city/${cityId}/operational-indicators`);
    },
    getPqrUserFigures(userId, year = '', month = '') {
        return this.get(`reporting/user/${userId}/pqr-figures`, { year, month });
    },
    exportUsageIndicators() {
        return this.get('reporting/usage-indicators-export');
    },
    getPqrParetoClients() {
        return this.get('reporting/pqrs/pareto-clients');
    },
    getManagementIndicators: (year, month, sortBy, sortDir) => base.get(`reporting/company/management-indicators/${year}/${month}`, { sortBy, sortDir }),
    getSupervisorIndicators: (year, month, sortBy, sortDir) => base.get(`reporting/company/supervisor-indicators/${year}/${month}`, { sortBy, sortDir }),
    registerManagementReportDownload: payload => base.post('reporting/management-report/download', payload)
}